import React, { Component } from "react";
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import UserService from '../../../Services/UserService';
import { Col, Row } from "react-bootstrap";
import debounce from 'es6-promise-debounce';
import userPlaceholderImg from "images/user_image_placeholder.svg";

class UserListControl extends Component {
  static propTypes = {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    disable: PropTypes.bool,
  };

  static defaultProps = {
    disable: false,
  };

  constructor(props) {
    super(props);

    this.ref = React.createRef();

    this.state = {
      errorMessage: null,
      value: props.value,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value != prevProps.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  static sortUsers(users) {
    return users.sort((a, b) => {
      return a.displayName.localeCompare(b.displayName);
    });
  }

  onChange = (usersChange) => {
    if (usersChange === null) {
      usersChange = [];
    }

    let addedUsers = usersChange
      .filter(addUser => !this.state.value.find(user => user.value == addUser.value))
      .map(u => {
        let newUser = { ...u };
        delete newUser.isSearchMenuOption;
        return newUser;
      });
    const users = UserListControl.sortUsers([...this.state.value, ...addedUsers]);

    if (this.props.onChange) {
      this.props.onChange(users);
    }

    this.setState({ value: users });
  }

  requestADUser = (searchText) => {

    if (!searchText || !searchText.trim().length) {
      return new Promise(r => r([]));
    }

    searchText = searchText.trim();

    return UserService.searchUser(searchText).then((users) => {
      return users.map(user => ({
        displayName: (user.firstName != null ? user.firstName : 'Unknown') + ' ' + (user.lastName != null ? user.lastName : 'Unknown'),
        firstName: user.firstName ? user.firstName : 'Unknown',
        lastName: user.lastName ? user.lastName : 'Unknown',
        upn: user.userPrincipalName,
        isSearchMenuOption: true,
        key: user.objectId,
        value: user.mail,
        photo: user.photoDataUrl,
      }));
    });
  }

  removeMember = (index) => {
    const users = [...this.state.value];
    users.splice(index, 1);
    this.setState({ value: users });
    if (this.props.onChange) {
      this.props.onChange(users);
    }
  }

  render() {
    return (
      <div
        className={
          'userListControl' +
          (this.state.preview ? ' userListControl-preview' : '') +
          (this.props.disable ? ' userListControl-disable' : '')
        }
        ref={e => this.ref = e}
      >
        { this.state.value.length > 0 && (
          <div className='userList'>
            { this.state.value.map((user, i) =>
              (
                <Row key={i} className="userListItem">
                  <Col className='identificationUserPicture'>
                    <img alt={user.displayName} className='faceCapture rounded-circle' src={user.photo ? user.photo : userPlaceholderImg} />
                  </Col>
                  <Col className='identificationLabel' md={true}>
                    <span className='identificationMail'>{user.value}</span><br />
                    <span className='identificationDisplayName'>{user.displayName}</span>
                  </Col>
                  <Col className="memberRemove">
                    <i onClick={() => this.removeMember(i)} className="icon-trash" />
                  </Col>
                </Row>
              ))}
          </div>
        )}
        {(this.props.disable) ? null : (
          <AsyncSelect
            focusOption
            cacheOptions
            defaultOptions
            loadOptions={debounce(this.requestADUser, 265)}
            className={"userListControlSelect"}
            classNamePrefix="react-select"
            value={this.state.value}
            isMulti
            name="users"
            isClearable={false}
            placeholder={'Search member'}
            noOptionsMessage={() => 'Member not found'}
            components={{
              DropdownIndicator: () => (<div className='userSelectorIndicator'><i className='icon-more-little'></i></div>),
              IndicatorSeparator: () => null,
              MultiValueContainer: (props) => {
                return !props.data.isSearchMenuOption ? null : (
                  <components.MultiValueContainer {...props} />
                );
              },
            }}
            formatOption
            formatOptionLabel={(user) => (
              !user.isSearchMenuOption ? null : (
                <Row className='userListControlOptionLabel'>
                  <Col className='identificationUserPicture'>
                    <img alt={user.displayName} className='faceCapture rounded-circle'
                      src={user.photo ? user.photo : userPlaceholderImg} />
                  </Col>
                  <Col className='identificationLabel' md={true}>
                    <span className='identificationMail'>{user.value}</span><br />
                    <span className='identificationDisplayName'>{user.displayName}</span>
                  </Col>
                </Row>
              )
            )}
            onChange={(tags) => this.onChange(tags)}
          />
        )}
      </div>
    );
  }
}

export default UserListControl;
